import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'reactstrap';
// import { Redirect } from 'react-router-dom';
import IncidentReport from './components/IncidentReport';
import SalesReport from './components/SalesReport';
import SalesView from './components/SalesView';
import ProfitReport from './components/ProfitReport';
import RemitReport from './components/RemitReport';
import CollectionReport from './components/CollectionReport';
import ReceivableReport from './components/ReceivableReport';

class Report extends PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        inventorytype: PropTypes.string,
      }),
    }),
  }

  static defaultProps = {
    match: '',
  };

  constructor() {
    super();
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  render() {
    const { match } = this.props;
    const { params } = match;
    const { pageType, pageid } = params;

    // if (this.userdata == null || ['1', '5'].indexOf(this.userdata.type) === -1) { // not admin
    //   return (<Redirect to="/login" />);
    // }

    return (
      <Container>
        <Row>
          {
            pageType && pageType === 'incident' ? <IncidentReport />
            : pageid === undefined && pageType === 'receivables' ? <ReceivableReport />
            : pageid === undefined && pageType === 'collections' ? <CollectionReport />
            : pageid === undefined && pageType === 'remits' ? <RemitReport />
            : pageid === undefined && pageType === 'profit' ? <ProfitReport />
            : pageid !== undefined && pageType === 'sales' ? <SalesView pageid={pageid} />
            : <SalesReport />
          }
        </Row>
      </Container>
    );
  }
}

export default Report;
